/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { relativePrioritySchema } from './relativePrioritySchema';

export const createItemRequestSchema = z.object({
  deadlineDateTime: z.iso.datetime().nullish(),
  description: z.string().nullish(),
  descriptionSyncSkipped: z.optional(z.boolean()),
  doneDateTime: z.iso.datetime().nullish(),
  earliestStartDateTime: z.iso.datetime().nullish(),
  estimationId: z.int().nullish(),
  externalCreatedAt: z.iso.datetime().nullish(),
  externalKey: z.string().nullish(),
  externalLink: z.string().nullish(),
  itemStatusId: z.int(),
  itemTypeId: z.int(),
  loopId: z.int(),
  name: z.string(),
  parentId: z.int().nullish(),
  plannedFinishDateTime: z.iso.datetime().nullish(),
  plannedStartDateTime: z.iso.datetime().nullish(),
  get relativePriority() {
    return z.union([relativePrioritySchema, z.null()]).optional();
  },
  schedulingType: z.enum(['ACTUALS_ONLY', 'PLANNED_AND_ACTUALS']),
  teamId: z.int().nullish(),
  timeSpentSeconds: z.int().nullish(),
});
